import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import SubmissionQAListItemDetailsPane from './SubmissionQAListItemDetailsPane.js'
import SubmissionQAListAddItemPopup from './SubmissionQAListAddItemPopup.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'

const SubmissionQAList = () => {
    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});
    let config = {};

    config.dataUrl = "/umbraco/api/SubmissionQAList/QA";
    config.getSingleItemUrl = "/umbraco/api/SubmissionQAList/QAItem";
    config.pageTitle = "Submissions Q&A";
    config.singleItemTitle = "Q&A item";
    config.entityType = "submissionqa";
    config.entityTypeId = 11;
    config.dataStructure = [];
    config.pageIcon = "fas fa-question-circle";
    config.breadcrumbs = [
        { "Name": "Country Registrations", "Link": "/your-medboard/country-registrations/" },
        { "Name": "Submissions", "Link": "/your-medboard/country-registrations/submissions/" },
        { "Name": "Submissions Q&A" }
    ];
    config.hideSelectAllCheckbox = true;
    config.enableMultiItemAIChatPane = true;
    config.showListTotalCount = true;
    config.listTotalCountURL = "/umbraco/api/SubmissionQAList/QACount";
    config.defaultOrderByField = "CreatedOn";
    // Mirrors Submissions.js/Certificates.js/etc.'s own deep-link mechanism: opening a QA
    // item updates the URL to ?qaId=<id> (DataTable.js's own preLoadItemId/
    // preLoadItemUrlParamName handling), and window.preloadQAId (set server-side by
    // _SubmissionsQA.cshtml from that same query param) re-opens it on a fresh page load.
    config.preLoadItemId = window.preloadQAId;
    config.preLoadItemUrlParamName = "qaId";
    config.enableCustomFields = true;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;

    useEffect(() => {
        loadStructure();
    }, []);

    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {

                    let renderComponent = FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text;

                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: renderComponent,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                        hasFilter: column.HasFilter,
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    const countryIdFilter = new URLSearchParams(window.location.search).get("filter[CountryId]");

    return (<>
        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
            {isLoadingStructure ? <>
                <LoadingSpinnerImage />
            </> : <>
        <DataTable
            dataTableStructure={dataTableStructure}
            defaultFilters={countryIdFilter ? [{ key: "CountryId", value: countryIdFilter }] : []}
            ItemDetailsPane={SubmissionQAListItemDetailsPane}
            AddItemPopup={SubmissionQAListAddItemPopup}
            ReloadStructureFunction={loadStructure} />
            </>}
        </>}
    </>);

};

export default SubmissionQAList;